module.exports = __webpack_public_path__ + "static/img/3-design-b3.bd0a8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-design-b3.jpg
// module id = hjXl
// module chunks = 0